import React from 'react';
import './FranchiseStory.css';
import muralImage from '../../Franchise_Page_Images/3-Franchise-ourstory-body-01.png';

const FranchiseStory: React.FC = () => {
  return (
    <section className="franchise-story">
      <div className="franchise-story__content">
        <h2 className="franchise-story__title">OUR STORY</h2>
        <div className="franchise-story__divider" />

        <p className="franchise-story__quote">
          We make cannabis worry-free for the modern wellness consumer. Our shopping experience is curated for people new to cannabis.
        </p>

        <div className="franchise-story__image-container">
          <img
            src={muralImage}
            alt="Sweetspot Store Interior with Worry Free Mural"
            className="franchise-story__image"
          />
        </div>

        <ul className="franchise-story__values">
          <li className="franchise-story__value">
            We give people control over their cannabis experience.
          </li>
          <li className="franchise-story__value">
            We positively impact the planet, people, and communities we serve.
          </li>
          <li className="franchise-story__value">
            We sell a product that helps people stress-less and enjoy-more.
          </li>
        </ul>
      </div>
    </section>
  );
};

export default FranchiseStory;
